import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "../Styles/ProductListing.css";
import Item from "../Components/Item";
import Layout from "../Components/Layout/Layout";
import Footer from "../Components/Layout/Footer";
import { Dropdown } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import Loader from "../Components/Layout/Loader";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Slider from "@mui/material/Slider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import InfiniteScroll from "react-infinite-scroll-component";

const capitalizeWords = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const accessToken = sessionStorage.getItem("auth");

export const ProductListing = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [allProduct, setAllProduct] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filterOptions, setFilterOptions] = useState({
    category: [],
    price: [],
    filter_data: {}
  });
  const [selectedFilters, setSelectedFilters] = useState({
    category: [],
    price: [0, 0],
    l1_primary_filter: [],
    l2_primary_filter: [],
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortBy, setSortBy] = useState("price asc");
  const [isAnyFilterChecked, setIsAnyFilterChecked] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const location = useLocation();
  const { categoryID } = location.state || {};
  const [noProductsMessage, setNoProductsMessage] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openAccordions, setOpenAccordions] = useState({});
  const [initialPriceRange, setInitialPriceRange] = useState([0, 0]);
  const [isPriceAdjusted, setIsPriceAdjusted] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const [clubVariants, setClubVariants] = useState(true);
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const isInitialMount = useRef(true);
  const isFetchingRef = useRef(false);
  const lastFetchedPageRef = useRef(0);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const updateUrlWithFilters = () => {
    const anyFiltersApplied =
      isPriceAdjusted ||
      selectedFilters.category.length > 0 ||
      selectedFilters.l1_primary_filter.length > 0 ||
      selectedFilters.l2_primary_filter.length > 0;

    if (!anyFiltersApplied && page === 1) {
      navigate(`/products`, { replace: true });
    } else {
      const queryString = buildQuery(page);
      navigate(`/products${queryString}`, { replace: true });
    }
  };

  // Initial load - fetch filters first, then products
  useEffect(() => {
    const initializeData = async () => {
      await fetchFilters();
      await fetchProducts(1);
    };
    initializeData();
  }, []);

  // Handle category ID from navigation
  // useEffect(() => {
  //   if (categoryID) {
  //     setSelectedFilters((prevFilters) => {
  //       const categoryIDString = categoryID.toString();
  //       if (!prevFilters.category.includes(categoryIDString)) {
  //         return {
  //           ...prevFilters,
  //           category: [...prevFilters.category, categoryIDString],
  //         };
  //       }
  //       return prevFilters;
  //     });
  //   }
  // }, [categoryID]);

  // NEW CODE - USE THIS
useEffect(() => {
  if (categoryID) {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      category: [categoryID.toString()],
    }));
  }
}, [categoryID]);

  // Handle filter changes - reset to page 1
  useEffect(() => {
    if (!isInitialMount.current) {
      setPage(1);
      lastFetchedPageRef.current = 0;
      setAllProduct([]);
      setFilteredProducts([]);
      setHasMore(true);
      fetchProducts(1);
    } else {
      isInitialMount.current = false;
    }
  }, [
    selectedFilters.category.join(','), 
    selectedFilters.l1_primary_filter.join(','), 
    selectedFilters.l2_primary_filter.join(','), 
    isPriceAdjusted
  ]);

  // Handle sort change
  useEffect(() => {
    handleSortChange(sortBy);
  }, [sortBy]);

  // Update URL when filters or page changes
  useEffect(() => {
    if (!isInitialMount.current) {
      updateUrlWithFilters();
    }
  }, [selectedFilters, isPriceAdjusted, page]);

  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
  };

  // Group variants by parent product ID
  const groupVariants = (products) => {
    const grouped = {};
    const result = [];

    products.forEach((product) => {
      const key = product.l1;

      if (!grouped[key]) {
        grouped[key] = {
          ...product,
          variants: [product],
          isGrouped: true,
        };
        result.push(grouped[key]);
      } else {
        grouped[key].variants.push(product);
      }
    });

    return result;
  };

  const fetchProducts = async (currentPage = page) => {
    // Prevent duplicate calls
    if (isFetchingRef.current || lastFetchedPageRef.current === currentPage || (!hasMore && currentPage > 1)) {
      return;
    }

    try {
      isFetchingRef.current = true;
      setLoading(true);
      
      const queryString = buildQuery(currentPage);
      const response = await axios.get(
        `https://tarunika.backendapihub.com/product/listview/products${queryString}`,
        {
          headers: {
            "access-token": accessToken,
            "Content-Type": "application/json",
          },
        }
      );

      const { status, message, data } = response.data;

      if (
        status === "success" &&
        message === "No data found" &&
        data.length === 1 &&
        Object.keys(data[0]).length === 0
      ) {
        setHasMore(false);
        setNoProductsMessage(message);
        return;
      }

      // Check if there are more products
      if (data.length < 9) {
        setHasMore(false);
      }

      const products = data.map((product) => ({
        category_id: product.category_id,
        product_id: product.product_id,
        name: product.product_name,
        desc: product.product_description,
        l1: product.l1_id,
        l2_id: product.l2_id,
        size: product.size_id,
        image: product.image
          ? `https://tarunika.backendapihub.com/images/${product.image}`
          : "default_image_url",
        price: product.price ? product.price.toString() : "0.00",
        ram: product.l1_primary_filter,
        memory: product.l2_primary_filter,
        isWishlist: product.isWishlist ?? false,
        stock_status: product.stock_status || "in_stock",
        color: product.color,
        size: product.size,
        color_swatch: product.color_swatch
          ? `https://tarunika.backendapihub.com/images/${product.color_swatch}`
          : null,
      }));

      if (currentPage === 1) {
        setAllProduct(products);
        setFilteredProducts(products);
      } else {
        setAllProduct((prev) => [...prev, ...products]);
        setFilteredProducts((prev) => [...prev, ...products]);
      }
      
      lastFetchedPageRef.current = currentPage;
      setNoProductsMessage("");
    } catch (error) {
      console.error("Error fetching products:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  useEffect(() => {
    if (filterOptions.price.length > 0 && initialPriceRange[0] === 0 && initialPriceRange[1] === 0) {
      setSelectedFilters((prevFilters) => ({
        ...prevFilters,
        price: [
          filterOptions.price[0].range[0],
          filterOptions.price[0].range[1],
        ],
      }));
    }
  }, [filterOptions.price]);

  useEffect(() => {
    const initialAccordions = {};

    Object.keys(filterOptions).forEach((key) => {
      initialAccordions[key] = true;
    });

    if (filterOptions.filter_data) {
      Object.keys(filterOptions.filter_data).forEach((key) => {
        initialAccordions[key] = true;
      });
    }

    setOpenAccordions(initialAccordions);
  }, [filterOptions]);

  const handleAccordionClick = (filterKey) => {
    setOpenAccordions((prevAccordions) => ({
      ...prevAccordions,
      [filterKey]: !prevAccordions[filterKey],
    }));
  };

  const fetchFilters = async () => {
    setLoadingFilters(true);
    try {
      const response = await axios.get(
        "https://tarunika.backendapihub.com/product/filter",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data.data || [];
      const filters = { category: [], price: [], filter_data: {} };

      let minPrice = Number.MAX_VALUE;
      let maxPrice = 0;

      data.forEach((categoryData) => {
        const categories = categoryData.category.map((item) => ({
          id: item.category_id,
          name: item.category_name,
        }));
        filters.category.push(...categories);

        if (categoryData.filter_data) {
          Object.keys(categoryData.filter_data).forEach((key) => {
            if (!filters.filter_data[key]) {
              filters.filter_data[key] = [];
            }
            filters.filter_data[key].push(...categoryData.filter_data[key]);
          });
        }

        minPrice = Math.min(minPrice, categoryData.initial_price);
        maxPrice = Math.max(maxPrice, categoryData.end_price);

        filters.price.push({
          value: `₹${categoryData.initial_price} - ₹${categoryData.end_price}`,
          range: [categoryData.initial_price, categoryData.end_price],
        });
      });
      
      setFilterOptions(filters);
      setInitialPriceRange([minPrice, maxPrice]);
      setSelectedFilters((prevFilters) => ({
        ...prevFilters,
        price: [minPrice, maxPrice],
      }));
    } catch (error) {
      console.error("Error fetching filters:", error);
    } finally {
      setLoadingFilters(false);
    }
  };

  const handleFilterChange = (filterKey, value) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };
      const filterData = filterOptions.filter_data[filterKey] || [];
      const selectedFilter = filterData.find((item) => item.value === value);

      if (filterKey === "category") {
        if (updatedFilters.category.includes(value)) {
          updatedFilters.category = updatedFilters.category.filter(
            (item) => item !== value
          );
        } else {
          updatedFilters.category.push(value);
        }
      }

      if (selectedFilter) {
        const column = selectedFilter.column;
        if (updatedFilters[column].includes(value)) {
          updatedFilters[column] = updatedFilters[column].filter(
            (item) => item !== value
          );
        } else {
          updatedFilters[column].push(value);
        }
      }

      return updatedFilters;
    });
  };

  useEffect(() => {
    const anyFiltersApplied =
      isPriceAdjusted ||
      selectedFilters.category.length > 0 ||
      selectedFilters.l1_primary_filter.length > 0 ||
      selectedFilters.l2_primary_filter.length > 0;

    setIsAnyFilterChecked(anyFiltersApplied);
  }, [selectedFilters, isPriceAdjusted]);

  useEffect(() => {
    const isPriceRangeDifferent =
      selectedFilters.price[0] !== initialPriceRange[0] ||
      selectedFilters.price[1] !== initialPriceRange[1];

    setIsPriceAdjusted(isPriceRangeDifferent);
  }, [selectedFilters.price, initialPriceRange]);

  const formatPrice = (price) => {
    const parsedPrice = parseFloat(price.replace(/[^0-9.]/g, ""));
    return isNaN(parsedPrice) ? 0 : parsedPrice;
  };

  const clearAllFilters = () => {
    setSelectedFilters({
      category: [],
      price: [
        filterOptions.price[0]?.range[0] || 0,
        filterOptions.price[0]?.range[1] || 10000,
      ],
      l1_primary_filter: [],
      l2_primary_filter: [],
    });
    setSortBy("price asc");
    setPage(1);
    lastFetchedPageRef.current = 0;
    setHasMore(true);
    setAllProduct([]);
    setFilteredProducts([]);
    setIsAnyFilterChecked(false);
    setIsPriceAdjusted(false);
    fetchProducts(1);
    document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.checked = false;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [sidebarOpen]);

  const handleSortChange = (sortOption) => {
    setSortBy(sortOption);
    setFilteredProducts((prevProducts) => {
      let sortedProducts = [...prevProducts];
      if (sortOption === "price desc") {
        sortedProducts.sort(
          (a, b) => formatPrice(b.price) - formatPrice(a.price)
        );
      } else if (sortOption === "price asc") {
        sortedProducts.sort(
          (a, b) => formatPrice(a.price) - formatPrice(b.price)
        );
      }
      return sortedProducts;
    });
  };

  const buildQuery = (currentPage) => {
    let query = `?page=${currentPage}&limit=9`;
    let filterConditions = [];

    if (selectedFilters.category.length > 0) {
      const categoryIds = selectedFilters.category
        .map((id) => `'${id}'`)
        .join(",");
      filterConditions.push(`category_id IN (${categoryIds})`);
    }

    if (
      selectedFilters.price.length > 0 &&
      selectedFilters.price[0] !== undefined &&
      isPriceAdjusted
    ) {
      const [minPrice, maxPrice] = selectedFilters.price;
      filterConditions.push(`price >= ${minPrice} AND price <= ${maxPrice}`);
    }

    if (selectedFilters.l1_primary_filter.length > 0) {
      const l1Filters = selectedFilters.l1_primary_filter
        .map((value) => `'${value}'`)
        .join(",");
      filterConditions.push(`l1_primary_filter IN (${l1Filters})`);
    }

    if (selectedFilters.l2_primary_filter.length > 0) {
      const l2Filters = selectedFilters.l2_primary_filter
        .map((value) => `'${value}'`)
        .join(",");
      filterConditions.push(`l2_primary_filter IN (${l2Filters})`);
    }

    if (filterConditions.length > 0) {
      query += `&filter=${encodeURIComponent(filterConditions.join(" AND "))}`;
    }

    return query;
  };

  const handlePriceSliderChange = (event, newValue) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      price: newValue,
    }));
  };

  // Load more function for InfiniteScroll
  const loadMoreProducts = () => {
    if (!loading && hasMore && !isFetchingRef.current) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchProducts(nextPage);
    }
  };

  // Prepare products for display based on grouping preference
  const productsToDisplay = clubVariants
    ? groupVariants(filteredProducts)
    : filteredProducts;

  return (
    <Layout setCartItems={setCartItems} cartItems={cartItems} isNavbar={true}>
      <div className="top-section"></div>
      <div className="product-listing">
        <div className="productlisting-header container d-flex justify-content-center align-items-center flex-column">
          <h6>CELEBRATE THE FESTIVE SPIRIT IN STYLE</h6>
          <h2>All Products</h2>
        </div>
      </div>
      <div className="productlisting-indexSort container d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between mb-3">
        <div className="d-flex justify-content-between w-100">
          <button
            className="btn-filter filter-btn styled-filter-btn d-flex align-items-center justify-content-center ms-2 mb-3 mb-sm-0"
            onClick={toggleSidebar}
            aria-label="Open Filters"
          >
            <div className="filter-container text-center">
              <h6 className="filter mb-0 me-2">FILTERS</h6>
              <FilterAltIcon fontSize="small" className="fillicon" />
            </div>
          </button>

          <div className="productlisting-sort ms-sm-2">
            <div className="btn-group custom-btn-group">
              <Dropdown onToggle={handleDropdownToggle}>
                <Dropdown.Toggle className="btn custom-btn1" id="sortDropdown">
                  Sort by:{" "}
                  {sortBy === "price desc" ? "High to Low" : "Low to High"}{" "}
                  <span>
                    {dropdownOpen ? (
                      <i className="bi bi-chevron-up"></i>
                    ) : (
                      <i className="bi bi-chevron-down"></i>
                    )}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => handleSortChange("price desc")}>
                    Price: High to Low
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => handleSortChange("price asc")}>
                    Price: Low to High
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div className="product-list notranslate">
        <div className="container">
          <div className="row">
            <div
              className={`col-lg-3 col-sm-12 ${
                sidebarOpen ? "d-block" : "d-none"
              } d-lg-block`}
            >
              <div
                ref={sidebarRef}
                className={`sidebar ${sidebarOpen ? "open" : ""}`}
              >
                <div
                  className={`accordion ${loadingFilters ? "loading" : ""}`}
                  id="filterAccordion"
                >
                  {loadingFilters ? (
                    <div className="loader">
                      <Loader />
                    </div>
                  ) : (
                    <>
                      <button
                        className="btn-close-filter"
                        onClick={toggleSidebar}
                        aria-label="Close Filter"
                      >
                        <i className="bi bi-x-circle"> CLOSE FILTER</i>
                      </button>

                      <button
                        className="clear-all-btn btn mb-3 mb-sm-0"
                        onClick={clearAllFilters}
                        style={{
                          display: isAnyFilterChecked ? "block" : "none",
                        }}
                      >
                        Clear All
                      </button>

                      <div className="accordion-item">
                        <h2 className="category-top accordion-header">
                          <div
                            className="d-flex justify-content-between align-items-center accordion-header"
                            onClick={() => handleAccordionClick("category")}
                            aria-expanded={openAccordions["category"] || false}
                            style={{ cursor: "pointer", paddingTop: "10px" }}
                          >
                            <span>Categories</span>
                            {openAccordions["category"] ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </div>
                        </h2>
                        <div
                          className={`accordion-collapse collapse ${
                            openAccordions["category"] ? "show" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <ul className="list-unstyled">
                              {filterOptions.category.map((item, idx) => {
                                const isChecked =
                                  selectedFilters.category.includes(
                                    item.id.toString()
                                  );
                                return (
                                  <li key={idx} style={{ paddingTop: "10px" }}>
                                    <input
                                      type="checkbox"
                                      id={`category-${item.id}`}
                                      value={item.id}
                                      checked={isChecked}
                                      onChange={() =>
                                        handleFilterChange(
                                          "category",
                                          item.id.toString()
                                        )
                                      }
                                      style={{ accentColor: "#ffd404" }}
                                    />
                                    <label
                                      htmlFor={`category-${item.id}`}
                                      style={{
                                        paddingLeft: "8px",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {item.name}
                                    </label>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>

                      <hr className="full-width-line" />

                      {Object.keys(filterOptions.filter_data || {}).map(
                        (filterKey) => (
                          <div key={filterKey} className="accordion-item">
                            <h2 className="accordion-header">
                              <div
                                className="d-flex justify-content-between align-items-center accordion-header"
                                type="button"
                                onClick={() => handleAccordionClick(filterKey)}
                                aria-expanded={
                                  openAccordions[filterKey] || false
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <span>{capitalizeWords(filterKey)}</span>
                                {openAccordions[filterKey] ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </div>
                            </h2>
                            <div
                              className={`accordion-collapse collapse ${
                                openAccordions[filterKey] ? "show" : ""
                              }`}
                            >
                              <div className="accordion-body">
                                <ul className="list-unstyled">
                                  {(
                                    filterOptions.filter_data[filterKey] || []
                                  ).map((item, idx) => (
                                    <li
                                      key={idx}
                                      style={{ paddingTop: "10px" }}
                                    >
                                      <input
                                        type="checkbox"
                                        id={`${filterKey}-${idx}`}
                                        value={item.value}
                                        checked={
                                          item.column && 
                                          selectedFilters[item.column]?.includes(item.value)
                                        }
                                        onChange={() =>
                                          handleFilterChange(
                                            filterKey,
                                            item.value
                                          )
                                        }
                                        style={{ accentColor: "#ffd404" }}
                                      />
                                      <label
                                        htmlFor={`${filterKey}-${idx}`}
                                        style={{
                                          paddingLeft: "8px",
                                          textTransform: "capitalize",
                                          cursor: "pointer"
                                        }}
                                      >
                                        {item.value}
                                      </label>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                            <hr className="full-width-line" />
                          </div>
                        )
                      )}

                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <div
                            className="d-flex justify-content-between align-items-center accordion-header"
                            type="button"
                            onClick={() => handleAccordionClick("price")}
                            aria-expanded={openAccordions["price"] || false}
                            style={{ cursor: "pointer" }}
                          >
                            <span>Price</span>
                            {openAccordions["price"] ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </div>
                        </h2>
                        <div
                          className={`accordion-collapse collapse ${
                            openAccordions["price"] ? "show" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <div className="price-slider">
                              <label>
                                ₹{selectedFilters.price[0]} - ₹
                                {selectedFilters.price[1]}
                              </label>
                              <Slider
                                value={selectedFilters.price}
                                onChange={handlePriceSliderChange}
                                valueLabelDisplay="auto"
                                min={filterOptions.price[0]?.range[0] || 0}
                                max={filterOptions.price[0]?.range[1] || 10000}
                                disableSwap
                                sx={{ color: "#ffd404" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Product Listings */}
            <div
              className="col-lg-9 col-md-12 notranslate"
              style={{ boxSizing: "border-box" }}
            >
              <InfiniteScroll
                dataLength={productsToDisplay.length}
                next={loadMoreProducts}
                hasMore={hasMore}
                loader={loading ? <Loader /> : null}
                style={{ overflow: 'visible' }}
              >
                <div
                  className="row justify-content-start"
                  style={{ display: "flex", flexWrap: "wrap", margin: "0" }}
                >
                  {productsToDisplay.length > 0 ? (
                    productsToDisplay.map((product, index) => (
                      <div
                        key={`${product.product_id}-${index}`}
                        className="col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-4"
                      >
                        <Item
                          {...product}
                          img={product.image}
                          setCartItems={setCartItems}
                          cartItems={cartItems}
                          isWishlist={product.isWishlist}
                          isGrouped={clubVariants && product.isGrouped}
                          variants={
                            clubVariants && product.isGrouped
                              ? product.variants
                              : []
                          }
                        />
                      </div>
                    ))
                  ) : (
                    !loading && (
                      <div className="no-data-container">
                        <p className="no-data-text">No products found.</p>
                      </div>
                    )
                  )}
                </div>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
      <Footer showBothDivs={false} />
    </Layout>
  );
};

export default ProductListing;